import { Capacitor, registerPlugin } from '@capacitor/core';

// Pluginul LOCAL de urmarire GPS din aplicatia Android (vezi GpsTrackerPlugin.java in
// transport-android). Exista doar in APK-ul nou; in browser / PWA / un APK mai vechi
// `NATIV_DISPONIBIL` e fals, iar Cursa GPS foloseste geolocatia browserului (merge doar
// cu aplicatia pe ecran, limitare a browserelor).
const GpsTracker = registerPlugin('GpsTracker');

export const NATIV_DISPONIBIL =
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('GpsTracker');

export default GpsTracker;
